import React, { useState, useEffect } from 'react';
import { QuestionSetList } from './QuestionSetList';
import { QuestionSetDetail } from './QuestionSetDetail';

interface QuestionBankModuleProps {
  onOpenTopUp?: () => void;
}

export const QuestionBankModule: React.FC<QuestionBankModuleProps> = ({
  onOpenTopUp
}) => {
  const [selectedSetId, setSelectedSetId] = useState<string | null>(null);

  // Sync with URL pathname
  useEffect(() => {
    if (typeof window === 'undefined') return;

    const parseSetIdFromPath = () => {
      const pathname = window.location.pathname;
      const match = pathname.match(/\/ngan-hang-cau-hoi\/([a-zA-Z0-9_-]+)/);
      if (match && match[1]) {
        setSelectedSetId(match[1]);
      } else {
        setSelectedSetId(null);
      }
    };

    parseSetIdFromPath();
    window.addEventListener('popstate', parseSetIdFromPath);
    return () => {
      window.removeEventListener('popstate', parseSetIdFromPath);
    };
  }, []);

  const handleOpenSet = (setId: string) => {
    setSelectedSetId(setId);
    if (typeof window !== 'undefined') {
      window.history.pushState({ setId }, '', `/ngan-hang-cau-hoi/${setId}`);
    }
  };

  const handleBackToList = () => {
    setSelectedSetId(null);
    if (typeof window !== 'undefined') {
      window.history.pushState({}, '', '/ngan-hang-cau-hoi');
    }
  };

  return (
    <div className="w-full">
      {selectedSetId ? (
        <QuestionSetDetail
          setId={selectedSetId}
          onBack={handleBackToList}
          onOpenTopUp={onOpenTopUp}
        />
      ) : (
        <QuestionSetList
          onOpenSet={handleOpenSet}
          onOpenTopUp={onOpenTopUp}
        />
      )}
    </div>
  );
};
